import styled from 'styled-components';

export const ProfileInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  background: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey003};
  box-shadow: 0px 2px 4px rgba(${({ theme }) => theme.colors.rgb.blue8PercentOpacity});
  border-radius: 8px;
`;

export const MemberName = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const Points = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme, isBlocked }) => (isBlocked ? theme.colors.grey400 : theme.colors.grey600)};
`;

export const PointsIcon = styled.span`
  position: relative;
  width: 20px;
  height: 20px;
  margin-inline-end: 8px;
  background: ${({ theme, isBlocked }) =>
    isBlocked
      ? theme.colors.grey200
      : `linear-gradient(
          180deg,
          ${theme.colors.yellowMain} 2.61%,
          ${theme.colors.yellowDark} 100%
        );
`};
  border-radius: 50%;
  &::after {
    content: ${'"\\e912"'};
    position: absolute;
    font-family: 'icomoon' !important;
    font-size: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${({ theme, isBlocked }) =>
      isBlocked ? theme.colors.grey400 : theme.colors.orangeDark};
  }
`;

export const PointsActionsButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
`;

export const BlockedUserTag = styled.div`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.redLight};
  border: 1px solid ${({ theme }) => theme.colors.redDark};
  border-radius: 4px;
  padding: 8px 24px;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.grey600};
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`;

export const BlockIcon = styled.span`
  margin-inline-end: 8px;
  &::after {
    content: ${'"\\e915"'};
    font-family: 'icomoon' !important;
    font-size: 14px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${({ theme }) => theme.colors.redDark};
  }
`;

export const LoaderWrapper = styled.div`
  display: inline-block;
  margin-inline-end: 8px;
`;
